import { RegionalSubstitutionStatus } from "@/@types/regional-substitution";

export const STATUS_LABELS: Record<RegionalSubstitutionStatus, string> = {
  [RegionalSubstitutionStatus.SCHEDULED]: "Agendado",
  [RegionalSubstitutionStatus.ACTIVE]: "Vigente",
  [RegionalSubstitutionStatus.ENDED]: "Encerrado",
  [RegionalSubstitutionStatus.INACTIVATED]: "Cancelado",
};

export const STATUS_COLORS: Record<RegionalSubstitutionStatus, string> = {
  [RegionalSubstitutionStatus.SCHEDULED]: "bg-amber-100 text-amber-800",
  [RegionalSubstitutionStatus.ACTIVE]: "bg-green-100 text-green-800",
  [RegionalSubstitutionStatus.ENDED]: "bg-gray-100 text-gray-700",
  [RegionalSubstitutionStatus.INACTIVATED]: "bg-red-100 text-red-700",
};

export const EDITABLE_STATUSES: ReadonlyArray<RegionalSubstitutionStatus> = [
  RegionalSubstitutionStatus.SCHEDULED,
];

export const CANCELABLE_STATUSES: ReadonlyArray<RegionalSubstitutionStatus> = [
  RegionalSubstitutionStatus.SCHEDULED,
  RegionalSubstitutionStatus.ACTIVE,
];
